import React from 'react'

export default function LoadingSpinner() {
    return (
        <div className='loading-container'>
            <div className='loading-animation'></div>
        </div>
    )
}
